// extracted by mini-css-extract-plugin
export default {"button":"_3YI8","s2":"N_JL","position":"g86T","active":"R89u","blue":"cUEC","green":"_58z","red":"HTjW","s0":"ZErk","s1":"y3Pl"};